import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateLoader, TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpJsonUtilities } from './http/http-json-utilities.service';
import { ActivityService } from './activity/activity.service';
import { HttpConfigService } from './http/http-config.service';
import { AuthInterceptor } from './services/auth.interceptor';

import {
  AccountClient,
  API_BASE_URL,
  ClientClient,
  ExportInterfaceConfigurationClient,
  ExportInterfaceEmailTemplateClient,
  ExportInterfaceActivationEmailTemplateClient,
  ExportInterfaceExecutionLogClient,
  ExportInterfaceFieldAssignmentTemplateClient,
  ExportInterfaceActivationEmailClient,
  ProductAssetClient,
  BrandLogoClient,
  AssetStorageClient,
  ExportInterfaceFieldValueReplacementClient,
  AssetStorageSettingClient,
  UserAccountClient,
  ImportConfigurationClient,
  ManualImportClient,
  ImportProtocolClient,
  EmailAccountSettingsClient,
  AcodisWorkflowClient,
  VendorScoreCardClient,
  VendorScoreCardAdminClient,
  AssetCollectionClient,
  VendorScoreCardSurveyClient,
  AssetCollectionPublicViewClient,
} from './models/models.swagger.generated';

import { AppErrorMessagesService } from './services/app-error-messages.service';
import { EnumTranslationService } from './services/enum-translation.service';

import { environment } from '../../environments/environment';
import { SpinnerService } from './spinner/spinner.service';
import { LoginProxy } from './http/login-proxy.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {
  CommandColumnService,
  EditService,
  FilterService,
  PageService,
  RowDDService,
  SearchService,
  SortService,
  ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import { EnumFilterService } from './services/enum-filter.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem(environment.localStorageToken);
}

@NgModule({ declarations: [],
    exports: [
        //BrowserAnimationsModule, // WARNING: do not use browser animations module here, it will cause errors with syncfusion V25+
        FontAwesomeModule,
        NgIdleKeepaliveModule,
    ], imports: [CommonModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        //BrowserAnimationsModule, // WARNING: do not use browser animations module here, it will cause errors with syncfusion V25+
        FontAwesomeModule,
        /* AgmCoreModule.forRoot({
         apiKey: environment.googleMapsApisKey
        }), */
        NgIdleKeepaliveModule.forRoot()],
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: API_BASE_URL, useValue: environment.apiServerUrl },
        HttpClient,
        HttpJsonUtilities,
        HttpConfigService,
        SpinnerService,
        TranslateService,
        TranslatePipe,
        ActivityService,
        LoginProxy,
        AppErrorMessagesService,
        EnumTranslationService,
        EnumFilterService,
        /* swagger clients */
        AccountClient,
        UserAccountClient,
        ClientClient,
        ExportInterfaceConfigurationClient,
        ExportInterfaceEmailTemplateClient,
        ExportInterfaceActivationEmailTemplateClient,
        ExportInterfaceFieldAssignmentTemplateClient,
        ExportInterfaceExecutionLogClient,
        ExportInterfaceActivationEmailClient,
        ProductAssetClient,
        BrandLogoClient,
        AssetStorageClient,
        ExportInterfaceFieldValueReplacementClient,
        AssetStorageSettingClient,
        AssetCollectionClient,
        ImportConfigurationClient,
        ManualImportClient,
        ImportProtocolClient,
        EmailAccountSettingsClient,
        AcodisWorkflowClient,
        VendorScoreCardClient,
        VendorScoreCardSurveyClient,
        VendorScoreCardAdminClient,
        AssetCollectionPublicViewClient,
        /* Syncfusion services */
        PageService,
        ToolbarService,
        FilterService,
        SortService,
        EditService,
        CommandColumnService,
        SearchService,
        RowDDService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class BaseModule {
}
